{
  "adobeExperienceCloudNoOrgsSelect": "选择其他组织帐户",
  "help": "帮助",
  "newAnnouncement": "有新公告",
  "notification": "通知和公告",
  "profile": "个人资料",
  "searchButton": "搜索",
  "sidenavMenuCloseTooltip": "关闭菜单",
  "sidenavMenuOpenTooltip": "打开菜单",
  "solutionSwitcher": "切换至其他解决方案",
  "unread": "未读通知"
}
